// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsAndConditionForm_container_36CeN","selectPadding":"TermsAndConditionForm_selectPadding_EN-Jx"};